import axios from '../plugins/axios'

const API_URL = process.env.VUE_APP_API_URL + '/metrics/'
class MetricsAPI {
  motorbikesTwoMonth(query) {
    return axios
      .get(`${API_URL}/motorbikes-two-months`, {
        params: query
      })
      .then(response => {
        return response.data
      })
  }
  mileageTwoMonth(query) {
    return axios
      .get(`${API_URL}/mileage-two-months`, {
        params: query
      })
      .then(response => {
        return response.data
      })
  }
  daysTwoMonth(query) {
    return axios
      .get(`${API_URL}/days-two-months`, {
        params: query
      })
      .then(response => {
        return response.data
      })
  }
  maintenanceCostTwoMonth(query) {
    return axios
      .get(`${API_URL}/maintenance-cost-two-months`, {
        params: query
      })
      .then(response => {
        return response.data
      })
  }
  motorbikeOdometer(query) {
    return axios
      .get(`${API_URL}/motorbike-odometer`, {
        params: query
      })
      .then(response => {
        return response.data
      })
  }
  motorbikesOdometerEvolution(query) {
    return axios
      .get(`${API_URL}/motorbikes-odometer-evolution`, {
        params: query
      })
      .then(response => {
        return response.data
      })
  }
}
export default new MetricsAPI()